module.exports = __webpack_public_path__ + "static/images/star-unselect.3bYeSZu.svg";